import { SearchElementDateRange, SearchTaskFilter } from '@askporter/grieg-types';
import { cloneDeep } from 'lodash';
import { TaskState } from '../pages/App/Tasks/types';

/**
 * Transforms state into object suitable for POST request
 * @param filter - object containing filters from state
 *
 * @returns object containing transformed filters
 */
export const generateTaskSearchFilters = (filter: TaskState['search']['filter']): Partial<SearchTaskFilter> => {
  const filters: SearchTaskFilter = cloneDeep(filter);

  // check other filters and remove any empties
  Object.keys(filter).forEach((key: keyof SearchTaskFilter) => {
    // check for empty arrays
    if (Array.isArray(filters[key])) {
      const arrayFilter = filters[key] as Array<string>;
      if (arrayFilter.length < 1) delete filters[key];
    }

    // check for date types with both elements (before & after) missing
    else if (key !== 'actionOn' && 'before' in filters[key] && 'after' in filters[key]) {
      const dateFilter = filters[key] as SearchElementDateRange;
      if (!dateFilter.before && !dateFilter.after) delete filters[key];
    }
  });

  return filters;
};
